import {mount} from "svelte";
import App from "./App.svelte";

/** @type {any} */
const app = mount(App, {target: document.body});

export default app;